// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "1850" ? "monaco-editor" : chunkId) + "." + {"1461": "fb79ebbc","1850": "e56fa031","3997": "91aeb0c5","6839": "a7d218b9","718": "7a250205",}[chunkId] + ".css"
}